
import React from 'react';
import {observer} from "mobx-react";
import {GameInfo} from '../../../../services/games/game-info';
import {LiveStreamSlideFooterComponent} from './components/live-stream-slide-footer/live-stream-slide-footer.component';
import {VideoSlideLayoutComponent} from '../../../video-slide-layout/video-slide-layout/video-slide-layout.component';
import {VideoSlideContentLayoutComponent} from '../../../video-slide-layout/video-slide-content-layout/video-slide-content-layout.component';
import {VideoSlideFooterLayoutComponent} from '../../../video-slide-layout/video-slide-footer-layout/video-slide-footer-layout.component';
import {LiveStreamSlideHlsPocPlayerComponent} from './components/live-stream-slide-player/live-stream-slide-hls-poc-player.component';

interface LiveStreamHlsPocSlideComponentProps {
    gameInfo: GameInfo;
}


//once HLS POC ends & it will be approved, this will become the static video slide

export const LiveStreamHlsPocSlideComponent: React.FC<LiveStreamHlsPocSlideComponentProps> = observer((props) => {

    return (
        <VideoSlideLayoutComponent>
            <VideoSlideContentLayoutComponent>
                <LiveStreamSlideHlsPocPlayerComponent gameInfo={props.gameInfo} />
            </VideoSlideContentLayoutComponent>
            <VideoSlideFooterLayoutComponent
                gameInfo={props.gameInfo}
                secondaryText={<LiveStreamSlideFooterComponent gameInfo={props.gameInfo} type={"bets"} />}
            />
        </VideoSlideLayoutComponent>
    )
})